<div class="pago-page">
  <div class="pago-card" *ngIf="status() as st">
    <ng-container *ngIf="st === 'succeeded'">
      <div class="pago-icon pago-icon--ok">
        <i class="pi pi-check-circle"></i>
      </div>
      <h2 class="pago-title">{{ 'payment_success_title' | translateText }}</h2>
      <p class="pago-desc">{{ 'payment_success_desc' | translateText }}</p>
    </ng-container>

    <ng-container *ngIf="st === 'failed'">
      <div class="pago-icon pago-icon--error">
        <i class="pi pi-times-circle"></i>
      </div>
      <h2 class="pago-title">{{ 'payment_failed_title' | translateText }}</h2>
      <p class="pago-desc">{{ 'payment_failed_desc' | translateText }}</p>
    </ng-container>

    <ng-container *ngIf="st === 'pending'">
      <div class="pago-icon pago-icon--pending">
        <i class="pi pi-clock"></i>
      </div>
      <h2 class="pago-title">{{ 'payment_pending_title' | translateText }}</h2>
      <p class="pago-desc">{{ 'payment_pending_desc' | translateText }}</p>
    </ng-container>
  </div>
</div>
